<template>
	<notifications classes="vue-notification teaming-notification" />
	<notifications classes="vue-notification teaming-notification connectivity-notification" group="connectivity" />
	<router-view/>
	<AppConfirmationDialogHOC />
	<TrialEndDialogHOC v-if="showTrialEndDialog && isVerified" />
	<GlobalNewOneOnOneDialogHOC />
</template>

<script>
import config from "./config";
import { mapGetters } from "vuex";
import { computed } from "vue";
import AppConfirmationDialogHOC from "./components/AppConfirmationDialogHOC";
import GlobalNewOneOnOneDialogHOC from "./components/GlobalNewOneOnOneDialogHOC.vue";
import TrialEndDialogHOC from "./components/TrialEndDialogHOC";

export default {
	name: "App",
	components: {
		AppConfirmationDialogHOC,
		TrialEndDialogHOC,
		GlobalNewOneOnOneDialogHOC,
	},
	provide() {
		return {
			userProfile: computed( () => this.userProfile ),
			isLoggedIn: computed( () => this.isLoggedIn ),
			isVerified: computed( () => this.isVerified ),
			config,
		};
	},
	computed: {
		...mapGetters( "host-userProfile", [
			"userProfile",
			"isLoggedIn",
			"isVerified",
		] ),
		showTrialEndDialog() {
			if ( !this.isLoggedIn ) {
				return false;
			}
			const { path: routePath, } = this.$route;
			return this.userProfile?.isFreeTrialExpired &&
				this.userProfile?.showPaymentOption &&
				!routePath.startsWith( "/me/settings" );
		},
	},
};
</script>

<style lang="scss">
@import '@/theme/teaming.default.scss';

// see: https://github.com/kyvg/vue3-notification#styling
.teaming-notification {
	.notification-content {
		@include font-and-line-for(-1);
		font-weight: 600;
	}
}
</style>
